import { toast } from "react-toastify";
import { generatePaymentLinkCheckout } from "../../../utils/general";
import { CopyButton, TD, TableBodyText } from "./Table.styles";

export interface TableBodyItem {
  dateCreated: string;
  productNo: string;
  shortcode: string;
}

export const mapPaymentLinkTableData = (tableBody: TableBodyItem) => {
  const linkToCopy = generatePaymentLinkCheckout(tableBody.shortcode);
  const handleCopy = () => {
    navigator.clipboard.writeText(linkToCopy);
    toast.success("payment link copied to clipboard");
  };

  return (
    <>
      <TD>{tableBody.productNo || "N/A"}</TD>
      <TD>{tableBody.shortcode}</TD>
      <TD>
        <TableBodyText>
          <CopyButton onClick={handleCopy}>
            <img src="/assets/svg/copy.svg" alt="Copy Icon" />
            Copy Link
          </CopyButton>

          {/* <CopyLinkButton>
                <Copy onClick={handleCopyButtonClick}>
                  <GoCopy />
                  Copy Link
                </Copy>
                <Share onClick={openShareModal}>
                  <IoMdShare />
                  Share Link
                </Share>
                {isShareModalOpen && (
                  <ShareModal
                    isOpen={isShareModalOpen}
                    onClose={closeShareModal}
                    linkToCopy={linkToCopy}
                  />
                )}
                <Share onClick={openQrCodeModal}>
                  <MdOutlineQrCodeScanner />
                  QR Code
                </Share>
                {isQrCodeModalOpen && <QrCode onCancel={closeModal} url={linkToCopy} />}
              </CopyLinkButton> */}
        </TableBodyText>
      </TD>
      {/* <IconTD cellWidth={cellwidth.icon}>
      <img src="/assets/svg/icon.svg" alt="" />
    </IconTD> */}
    </>
  );
};
